import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@optsolservices/ngx-notification';
import { Subscription } from 'rxjs';
import { BaseService } from 'src/app/core/services/base.service';
import { GenericService } from 'src/app/generic/generic.service';
import { PosStoreService } from '../../pos.store.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { InvoiceCreateCreditNoteDialogComponent } from './invoice-create-credit-note-dialog/invoice-create-credit-note-dialog.component';
import { SendEmailConfirmDialogComponent } from '../../components/send-email-confirm-dialog/send-email-confirm-dialog.component';
import { PosInvoicePayWithDepositDialogComponent } from '../../components/pos-invoice-pay-with-deposit/pos-invoice-pay-with-deposit-dialog.component';
import { PosInvoicePayWithMoneyEquipmentComponent } from '../../components/pos-invoice-pay-with-money-equipment/pos-invoice-pay-with-money-equipment.component';
import { PosInvoiceRefundWithMoneyContainerComponent } from '../../components/pos-invoice-refund-with-money-container/pos-invoice-refund-with-money-container.component';
import { InvoiceEftRequestDialogComponent } from './invoice-eft-request-dialog/invoice-eft-request-dialog.component';
import { PrintTriggerDialogComponent } from 'src/app/shared/print-trigger-dialog/print-trigger-dialog.component';
import { InvoiceTransferCreditToDepositComponent } from './invoice-transfer-credit-to-deposit/invoice-transfer-credit-to-deposit.component';
import { InvoiceCreateCreditNoteLedaineDialogComponent } from './invoice-create-credit-note-ledaine-dialog/invoice-create-credit-note-ledaine-dialog.component';

@Component({
  selector: 'app-invoice-details',
  templateUrl: './invoice-details.component.html',
  styleUrls: ['./invoice-details.component.scss'],
})
export class InvoiceDetailsComponent implements OnInit, OnDestroy {
  paramSubscription: Subscription;
  invoice: any = null;
  compactView: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private baseService: BaseService,
    private dialog: MatDialog,
    private router: Router,
    private posStoreService: PosStoreService,
    private genericService: GenericService,
    private clipboard: Clipboard,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.paramSubscription = this.route.params.subscribe(params => {
      this.baseService.executeCommand<any>('portal_syspro_invoice_details_by_id', { invoiceNumber: params['invoiceNumber'] })
          .subscribe(response => {
            if (response.responseCode === 0) {
              this.invoice = response.data;
              // this.salesOrderChangedSubscription = this.posStoreService.salesOrderChanges()
              //   .subscribe(change => {
              //     if (change && change.salesOrderHeaderId === this.salesOrder.salesOrderHeaderId) {
              //       this.refresh();
              //     }
              //   });
            }
          });
    });
  }

  ngOnDestroy(): void {
    if (this.paramSubscription) { this.paramSubscription.unsubscribe(); }
    // if (this.salesOrderChangedSubscription) { this.salesOrderChangedSubscription.unsubscribe(); }
  }

  refresh() {
    this.baseService.executeCommand<any>('portal_syspro_invoice_details_by_id', { invoiceNumber: this.invoice.invoiceNumber })
          .subscribe(response => {
            if (response.responseCode === 0) {
              this.invoice = response.data;
              // this.salesOrderChangedSubscription = this.posStoreService.salesOrderChanges()
              //   .subscribe(change => {
              //     if (change && change.salesOrderHeaderId === this.salesOrder.salesOrderHeaderId) {
              //       this.refresh();
              //     }
              //   });
            }
          });
  }

  createCreditNote() {
    let ref: any;
    if (!this.invoice.creditNoteDialogCode || this.invoice.creditNoteDialogCode === 'NORMAL') {
      ref = this.dialog.open(InvoiceCreateCreditNoteDialogComponent, {
        data: this.invoice,
        width: '1000px'
      });

    } else {
      ref = this.dialog.open(InvoiceCreateCreditNoteLedaineDialogComponent, {
        data: this.invoice,
        width: '1000px'
      });
    }

    ref.afterClosed().subscribe(response => {
      this.refresh();
    });
  }

  generateCreditNoteDocument(dataItem: any) {
    const ref = this.dialog.open(PrintTriggerDialogComponent, {
      data: {
        title: 'Generating Credit Note Document',
        function: 'portal_syspro_order_create_print_trigger',
        postBody: dataItem
      },
      width: '600px'
    });

    ref.afterClosed().subscribe(response => {
        this.refresh();
    });

    // this.baseService.executeCommand<any[]>('portal_syspro_order_create_print_trigger', dataItem)
    //   .subscribe(response => {
    //     if (response.responseCode === 0) {
    //       this.refresh();
    //     }
    //   });
  }

  emailDocument(emailInfo: any) {
    const dialogRef = this.dialog.open(SendEmailConfirmDialogComponent, {
      width: '450px',
      data: {
        createEmailFunction: 'portal_syspro_order_create_email',
        email: emailInfo,
        form: {
          name: this.invoice.customerName,
          email: this.invoice.email
        }
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.refresh();
    });
  }

  downloadResource(resource: any) {
    this.baseService.downloadResource(resource.apiResourceKey, resource.fileName, resource.mimeType);
  }

  payInvoice() {
    const ref = this.dialog.open(PosInvoicePayWithMoneyEquipmentComponent, {
      data: this.invoice,
      width: '800px'
    });

    ref.afterClosed().subscribe(response => {
      this.refresh();
    });
  }

  payInvoiceFromDeposit() {
    const ref = this.dialog.open(PosInvoicePayWithDepositDialogComponent, {
      data: this.invoice,
      width: '500px'
    });

    ref.afterClosed().subscribe(response => {
      this.refresh();
    });
  }

  refundCredit() {
    const ref = this.dialog.open(PosInvoiceRefundWithMoneyContainerComponent, {
      data: this.invoice,
      width: '800px'
    });

    ref.afterClosed().subscribe(response => {
      this.refresh();
    });
  }

  requestEftRefund() {
    const ref = this.dialog.open(InvoiceEftRequestDialogComponent, {
      data: this.invoice,
      width: '600px'
    });

    ref.afterClosed().subscribe(formValue => {
      if (formValue) {
        this.baseService.executeCommand<any>('portal_pos_payment_create_eft_refund_request', formValue)
          .subscribe(response => {
            this.refresh();
          })
      } else {
        this.refresh();
      }
    });
  }

  transferCredit() {
    const ref = this.dialog.open(InvoiceTransferCreditToDepositComponent, {
      data: this.invoice,
      width: '600px'
    });

    ref.afterClosed().subscribe(response => {
      this.refresh();
    });
  }
}
